import { t } from 'i18next'

export const ORDER_IMPORT_TITLE = t('order.import.title')
